import React, {useState} from 'react';

import {IconSettings, ExpandableSection} from '@salesforce/design-system-react';

import Message from './Message'
import TwitterMessage from './TwitterMessage'

const MessageSection = ({message}) => {
  const [isOpen, setIsOpen] = useState(true)

  return (
    <IconSettings iconPath="/icons">
      <ExpandableSection
        id="controlled-expandable-section"
        isOpen={isOpen}
        onToggleOpen={() => setIsOpen(!isOpen)}
        title="Message"
      >
        {message.network == 'twitter' ? (
          <TwitterMessage twitterEmbedHTML={message.twitter_embed.html} />
        ) : (
          <Message message={message} />
        )}
      </ExpandableSection>
    </IconSettings>
  )
}

export default MessageSection
